import { Dictionary } from "lodash";

export interface IAppDefinitions {
    addressType: Dictionary<DefinitionsAddressType>;
    contactType: Dictionary<DefinitionsContactType>;
    regulationCode: Dictionary<DefinitionsRegulationCode>;
    country: Dictionary<DefinitionsCountry>;
    healthcareServiceProviderCategory: Dictionary<DefinitionsHealthcareServiceProviderCategory>;
    healthcareServiceSupplierCategory: Dictionary<DefinitionsHealthcareServiceSupplierCategory>;
    organizationType: Dictionary<DefinitionsOrganizationType>;
    organizationNameTag: Dictionary<DefinitionsOrganizationNameTag>;
    hierarchyType: Dictionary<DefinitionsHierarchyType>;
    numberOfBeds: Dictionary<DefinitionsNumberOfBeds>;
}

export interface AppDefinitionEntry {
    id: number;
    code: string;
    displayName: string;
    sortOrder: number;
}

export interface DefinitionsRegulationCode extends AppDefinitionEntry {}

export interface DefinitionsAddressType extends AppDefinitionEntry {}

export interface DefinitionsContactType extends AppDefinitionEntry {}

export interface DefinitionsCountry extends AppDefinitionEntry {
    iso2Code: string;
    iso3Code: string;
}

export interface DefinitionsHealthcareServiceProviderCategory extends AppDefinitionEntry {
    countryCode: string;
}

export interface DefinitionsHealthcareServiceSupplierCategory extends AppDefinitionEntry {}

export interface DefinitionsOrganizationType extends AppDefinitionEntry {}

export interface DefinitionsOrganizationNameTag extends AppDefinitionEntry {}

export interface DefinitionsHierarchyType extends AppDefinitionEntry {}

export interface DefinitionsNumberOfBeds {
    id: number;
    displayName: string;
}
